import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import useCopy from "../../hooks/useCopy";

interface ICopyButtonProps {
  /** Texto a copiar, ou função que o produz (para conteúdo caro de montar) */
  value: string | (() => string);
  label?: string;
  size?: "small" | "medium";
  disabled?: boolean;
}

const CopyButton: React.FC<ICopyButtonProps> = ({
  value,
  label,
  size = "small",
  disabled,
}) => {
  const { t } = useTranslation();
  const { copy } = useCopy();

  const handleCopy = () => {
    const text = typeof value === "function" ? value() : value;
    if (text) copy(text);
  };

  return (
    <Tooltip title={label ?? t("components.copyButton.copy") ?? "Copiar"}>
      <span>
        <IconButton size={size} onClick={handleCopy} disabled={disabled}>
          <ContentCopyIcon fontSize={size} />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default CopyButton;
